import {
  DeleteObservationRequest,
  ObservationControllerService
} from "@9amhealth/openapi";
import { Blac, Cubit } from "blac-next";
import reportErrorSentry from "src/lib/reportErrorSentry";
import LabResultsCubit from "./LabResultsCubit";

interface LabResultEraserState {
  isLoading: boolean;
}

export class LabResultDeleteCubit extends Cubit<LabResultEraserState> {
  public constructor() {
    super({
      isLoading: false
    });
  }

  public readonly deleteLabResultWeight = async (
    args: DeleteObservationRequest
  ) => {
    try {
      this.patch({ isLoading: true });
      await ObservationControllerService.deleteObservation(args);
    } catch (error) {
      reportErrorSentry(error);
    } finally {
      this.patch({ isLoading: false });
      const labResults = Blac.getBloc(LabResultsCubit, {
        id: this._id !== LabResultDeleteCubit.name ? this._id : undefined
      });
      await labResults.loadObservations();
    }
  };
}
